// we need to create own history
// so we can pass it to other parts of application
// i.e. api, not only react components

import {createBrowserHistory} from 'history';

export default createBrowserHistory({});